<div class="side-bar d-flex flex-dir-col">
    <div class="child-1 d-flex align-center just-space" *ngIf="callFromTrip">
        <div class="d-flex align-center gap-16">
            <div><img src="{{imgSrc}}assets/icons/left-arrow.svg" style="cursor: pointer;" (click)="goToDashboard()"
                    alt=""></div>
            <div class="d-flex align-center gap-8">
                <span class="h5">{{response?.tripDetails.tripId}}</span>
                <div class="direction d-flex align-center"><span class="h8-b">{{response?.tripDetails.direction === 'IN'
                        ? 'IN' : 'OUT' }}</span></div>
                <div class="planned d-flex align-center"><span *ngIf="response['tripDetails']['tripType']==='Regular'"
                        class="h8-b">PLANNED</span></div>
                <ng-container *ngIf="aiBotEnabled">
                    <img src="{{ASSETS_PATH_CONST.ASSISTANT_ICON}}" alt="assistant" class="assistant-icon" (click)="openAssistant()">
                </ng-container>
            </div>
        </div>

        <div *ngIf="false" class="toggle-button">
            <button (click)="tripDutyToggle('trip')"
                [ngClass]="{'selected-button':tripDutyToggler=='trip','transparent-button':tripDutyToggler!='trip'}"
                class="trip">
                <span class="h6">
                    Trip
                </span>
            </button>
            <button (click)="tripDutyToggle('duty')"
                [ngClass]="{'selected-button':tripDutyToggler=='duty','transparent-button':tripDutyToggler!='duty'}"
                class="duty">
                <span class="h6">
                    Duty
                </span>
            </button>
        </div>

        <div *ngIf="false">
            <button [ngClass]="{'selected-button':tripDutyToggler=='duty','transparent-button':tripDutyToggler!='duty'}"
                class="duty d-flex">
                <span class="h6 duty-color">
                    Duty View
                </span>
                <img src="{{imgSrc}}assets/icons/duty-view.svg" />
            </button>
        </div>
    </div>

    <!-- <div *ngIf="womenTravellingAlone" class="women-travel-warning d-flex just-space">
        <div class="d-flex gap-8">
            <img src="{{imgSrc}}assets/icons/warning.svg" />
            <span class="h7">Women Travelling alone</span>
        </div>
        <img src="{{imgSrc}}assets/icons/navigation-cancel.svg" />

    </div> -->


    <div *ngIf="safetyAlert&&safetyAlert.length > 0" class="women-travel-warning d-flex just-space">
        <div class="d-flex gap-8">
            <img [src]="ASSETS_PATH_CONST.ALERT_ICON" />
            <span class="h7">{{safetyAlert.join(',')}}</span>
        </div>
    </div>

    <div class="child-4">
        <app-attendance></app-attendance>
    </div>


    <div class="child-3 d-flex flex-dir-col">
        <div class="d-flex flex-dir-row just-space">
            <div class="d-flex gap-8 align-center">
                <div><span class="h7-b">Trip Details</span></div>
                <div class="pointer-cursor d-flex align-center"
                    [@expandedAnimation]="expandedToggler ? 'true' : 'false'" (click)="expandedToggle()">
                    <img [@rotateArrow]="expandedToggler ? 'true' : 'false'"
                        src="{{imgSrc}}assets/icons/down-arrow1.svg" alt="">

                </div>


            </div>
            <div (click)="nextTripPopup()" *ngIf="nextTrip">
                <span class="next-trip">Next Trip - {{nextTrip}}</span>
            </div>
        </div>

        <div [@expandCollapse]="expandedToggler ? 'expanded' : 'collapsed'" style="background: white;
        border-radius: 8px;" [ngStyle]="{'margin-top':expandedToggler?'8px':0}">
            <app-trip-info-card></app-trip-info-card>
        </div>

    </div>



    <div class="child-5 d-flex flex-dir-col just-space">

        <app-bus-stop-card
            [ngClass]="{'bus-stop-ended':response['tripDetails']['status']==='Ended','bus-stop':response['tripDetails']['status']!=='Ended','bus-stop-ended-escort':response['tripDetails']['status']==='Ended' && womenTravellingAlone}"
            [tripStatus]="response['tripDetails']['status']"></app-bus-stop-card>
        <div class="d-flex just-end replay-container" *ngIf="response['tripDetails']['status']==='Ended'">
            <button (click)="gotoTripReplay()" class="play-replay d-flex h7-b">Trip Replay <img
                    src="{{imgSrc}}assets/icons/play-replay.svg" /></button>
        </div>
    </div>

</div>


<div class="overlay" *ngIf="nextTripInfo">
    <div class="popup">
        <h2 style="font-size: 20px;font-weight:bold;margin-bottom: 0;">Next Trip</h2>
        <p class="h7" style="padding-bottom: 13px;border-bottom:1px solid lightgray;margin-top: 0;color:#6A737D">
            Information of next trip of vehicle.</p>
        <a class="close" (click)="nextTripInfo = false">&times;</a>
        <div class="content d-flex flex-dir-col gap-12">
            <div class="d-flex flex-dir-row just-space">
                <span class="h7-b">{{nextTripData.tripId}}</span>
                <div class="d-flex flex-dir-row gap-8">
                    <span
                        class="shift-time h7">{{nextTripData.shift.hour}}:{{nextTripData.shift.min}}&nbsp;{{nextTripData.direction}}</span>
                    <span class="trip-type h7">{{nextTripData['tripType']}}</span>
                </div>
            </div>

            <div class="d-flex flex-dir-row just-space">
                <div class="d-flex flex-dir-row gap-4 align-center">
                    <img src="{{imgSrc}}assets/icons/location.svg" />
                    <span
                        style="font-size:12px;min-width: 150px;line-height: 18px;">{{nextTripData.tripStartLocation}}</span>
                </div>
                <div class="d-flex flex-dir-row gap-4 align-center" *ngIf="nextTrip">
                    <img class="h7-b" src="{{imgSrc}}assets/icons/clock1.svg" />
                    <span class="h7-b" style="color:#6A737D">{{nextTrip}}</span>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="ai-bot-wrapper" *ngIf="isAssistantOpen" [hidden]="hideBot">
    <iframe [src]="aiBotURLSafe" allow="display-capture" frameborder="0"></iframe>
</div>



















<!-- 


 -->